function formatNumberToUs(value) {

    if (value === "0" || value === 0 || value === null) {
        return "0.00"
    }

    if (typeof value !== "number" && typeof value !== "string") {
        throw new Error("Input must be a number or a string representing a number");
    }

    const newValue = Number(value)


    return newValue.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}

export default formatNumberToUs;